import type { ReactElement } from 'react';

export type SpinnerSize = 'small' | 'medium' | 'large';

export interface SpinnerProps {
  readonly size?: SpinnerSize;
  readonly caption?: string;
}

// Pixel sizes pair with the .spinner class in index.css (which defaults to
// 16x16). We override width/height/border per size; the keyframe animation
// stays in CSS.
const SIZE_PX: Readonly<Record<SpinnerSize, number>> = Object.freeze({
  small: 12,
  medium: 20,
  large: 32,
});

export function Spinner({ size = 'medium', caption }: SpinnerProps): ReactElement {
  const px = SIZE_PX[size];
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        padding: 24,
      }}
    >
      <span
        className="spinner"
        aria-hidden="true"
        style={{ width: px, height: px, borderWidth: size === 'large' ? 3 : 2 }}
      />
      {caption && (
        <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>{caption}</span>
      )}
    </div>
  );
}
